import { render, staticRenderFns } from "./SectionDiscoverArea.vue?vue&type=template&id=e9b0c820&"
import script from "./SectionDiscoverArea.vue?vue&type=script&lang=js&"
export * from "./SectionDiscoverArea.vue?vue&type=script&lang=js&"
import style0 from "./SectionDiscoverArea.vue?vue&type=style&index=0&id=e9b0c820&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default})
